import 'react-native-gesture-handler'; // why
import {App as Lmao} from './src/App'

export default function App(props) {
    return ( <Lmao {...props}/> );
}